export default class NotImplementError extends Error {
  constructor(message) {
    super(message);
    this.name = "NotImplementError";
  }
}
